import React from 'react';
import Image from 'src/presentation/components/Image';
import { iconLogout, imageLogo } from 'src/integration/assets/AssetsProvider';
import styled, { css } from 'styled-components';
import colors from 'src/integration/styles/colors';
import Icon from 'src/presentation/components/ui/Icon';
import { useAuth } from 'src/toolkit/services/AuthProvider';
import BodyText from 'src/presentation/components/ui/BodyText';
import breakpoints from 'src/integration/styles/breakpoints';

const Root = styled.div`
  ${() => css`
    padding: 24px 40px;
    border-bottom: solid  1px;
    border-color: ${colors.grey3};
  `}
`;

const Content = styled.div`
  ${() => css`
      display: flex;
      justify-content: space-between;
      align-items: center;
      
    ${breakpoints.desktop`
      margin: auto;
      max-width: 1320px;
    `}
  `}
`;

const NavWrapper = styled.div`
  ${() => css`
      display: flex;
      align-items: center;
      gap: 90px;
  `}
`;


const Nav = styled('nav')`
  ${() => css``}
`;

const Menu = styled('ul')`
  ${() => css`
    display: flex;
    list-style-type: none;
  `}
`;

const Row = styled.div`
  ${() => css`
      display: flex;
      align-items: center;
      gap: 8px;
  `}
`;

const LogoutButton = styled(Row)`
  ${() => css`
      cursor: pointer;
  `}
`;

const BlueIcon = styled(Icon)`
  ${() => css`
      color: ${colors.primaryNewCar};
  `}
`;

const DesktopNavigation = () => {
  const { logOut } = useAuth();

  return (
    <Root>
      <Content>
        <Image icon={imageLogo} size={45} />
        <NavWrapper>
          <Nav>
            <Menu>
            </Menu>
          </Nav>
          <Row>
            <LogoutButton onClick={logOut}>
              <BodyText level={'b1-reg'} color={colors.primaryNewCar}>Log Out</BodyText>
              <BlueIcon icon={iconLogout} size={16} />
            </LogoutButton>
          </Row>
        </NavWrapper>
      </Content>
    </Root>
  );
};

export default DesktopNavigation;
